<template>
  <div class="report-container">
    <div class="report-header">
      <h2>Inventory Sales Performance Report</h2>
      <div class="header-actions">
        <button class="print-button" @click="printReport">Print Report</button>
      </div>
    </div>

    <div class="date-filters">
      <label>
        Start Date:
        <input type="date" v-model="startDate" />
      </label>
      <label>
        End Date:
        <input type="date" v-model="endDate" />
      </label>
      <button class="view-button" @click="fetchReport">View Report</button>
    </div>

    <div class="report-table">
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Item Name</th>
            <th>Quantity Sold</th>
            <th>Revenue Raised</th>
            <th>Profit Margin</th>
            <th>% of Total Quantity</th>
            <th>% of Total Revenue</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in reportData" :key="item.item_id">
            <td>{{ index + 1 }}</td>
            <td>
              <ItemName
                :ItemName="item.item_name"
                :ItemBrand="item.brand_name"
                :ItemStrength="item.item_strength"
              />
            </td>
            <td>{{ item.total_issued }}</td>
            <td>Ksh. {{ formatAmount(item.total_revenue) }}</td>
            <td>Ksh. {{ item.profit_margin }}</td>
            <td>
              <div class="bar-cell">
                <div
                  class="bar bar-alt"
                  :style="{
                    width:
                      find_percentage(item.total_revenue, totalRevenue) + '%',
                  }"
                ></div>
                <span class="bar-value"
                  >{{
                    find_percentage(item.total_revenue, totalRevenue)
                  }}%</span
                >
              </div>
            </td>

            <td>
              <div class="bar-cell">
                <div
                  class="bar"
                  :style="{
                    width:
                      find_percentage(item.total_issued, totalQuantity) + '%',
                  }"
                ></div>
                <span class="bar-value"
                  >{{
                    find_percentage(item.total_issued, totalQuantity)
                  }}%</span
                >
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="summary-row">
            <td colspan="2">Totals</td>
            <td>{{ totalQuantity }}</td>
            <td>Ksh. {{ formatAmount(totalRevenue) }}</td>
            <td>Ksh. {{ formatAmount(totalProfit) }}</td>
            <td colspan="2"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import ItemName from "../Inventory/components/ItemName.vue";
export default {
  name: "InventorySalesReport",
  data() {
    const today = new Date().toISOString().substr(0, 10);
    return {
      startDate: today,
      endDate: today,
      reportData: [],
      totalQuantity: 0,
      totalRevenue: 0,
      totalProfit: 0,
    };
  },
  components: {
    ItemName,
  },
  methods: {
    async fetchReport() {
      var req_body = { startDate: this.startDate, endDate: this.endDate };
      const url = `finance/inventory_and_sales`;
      const res = await generalApiRequest(url, "POST", req_body, 1);
      console.log(res);

      this.reportData = res.data;
      this.totalQuantity = res.totals.total_quantity_issued;
      this.totalRevenue = res.totals.total_revenue_raised;
      this.totalProfit = res.totals.total_profit;
    },
    find_percentage(amount, totals_of) {
      return Math.round(((amount * 100) / totals_of) * 100) / 100;
    },
    formatAmount(amount) {
      // Check if amount is a valid number
      if (amount === null || amount === undefined || isNaN(amount)) {
        return "0.00"; // You can return any default value here, like 'N/A' or '0.00'
      }

      // If valid, format the amount
      return amount.toLocaleString(undefined, { minimumFractionDigits: 2 });
    },
    // formatAmount(amount) {
    //   return amount.toLocaleString(undefined, { minimumFractionDigits: 2 });
    // },
    printReport() {
      window.print();
    },
  },
  mounted() {
    this.fetchReport();
  },
};
</script>

<style scoped>
.report-container {
  margin-top: 1em;
  padding: 1rem;
  border: 1px solid black;
  background-color: #ffffff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.bar-cell {
  /* display: flex;
  flex-direction: column;
  align-items: flex-start; */
}

.bar-value {
  margin-top: 4px;
  font-size: 0.85rem;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.header-actions {
  display: flex;
  gap: 0.5rem;
}

.print-button {
  background-color: #0069d9;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.print-button:hover {
  background-color: #0053b3;
}

.date-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1rem;
}

.date-filters label {
  font-weight: 500;
}

.date-filters input[type="date"] {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.view-button {
  background-color: #28a745;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.view-button:hover {
  background-color: #218838;
}

h2 {
  margin-bottom: 0.5rem;
}

.report-table table {
  width: 100%;
  border-collapse: collapse;
}

.report-table th,
.report-table td {
  border: 1px solid #ddd;
  padding: 0.75rem;
  text-align: left;
}

.report-table th {
  background: #f4f4f4;
}

.bar-cell {
  display: flex;
  align-items: center;
}

.bar {
  max-width: 70%;
  height: 8px;
  background: #007bff;
  border-radius: 4px;
  margin-right: 8px;
  transition: width 0.5s;
  flex-shrink: 0;
}

.bar-alt {
  background: #28a745;
}

.summary-row td {
  font-weight: bold;
  background: #f9f9f9;
}
</style>
